<template>
    <section>
        <div class="cover pr" :style="`background-image: url(${studio.thumb})`">
            <div class="cover-mask pa"></div>
            <div class="dancer-info">
                <div class="dancer-name">{{studio.name}}</div>
                <div class="dancer-fans">{{studio.fans}}粉丝 ۰ {{$view(studio.views)}}人气</div>
                <div class="dancer-digest">{{studio.digest || '该舞者暂时还没有简介QAQ'}}</div>
            </div>
        </div>
        <sort :sorts="[
            {id: 1, name: '视频', path: `/studios/${id}`, routeName: 'studioVideo'},
            {id: 2, name: '舞者', path: `/studios/${id}/dancers`, routeName: 'studioDancer'},
            {id: 2, name: '门店', path: `/studios/${id}/stores`, routeName: 'studioStore'},
            {id: 2, name: '资讯', path: `/studios/${id}/info`, routeName: 'studioInfo'}
        ]"></sort>
        <router-view :studio="studio.name" :avatar="studio.thumb"></router-view>
    </section>
</template>

<script>
    import sort from '../contest/Nav';

    export default {
        components: {
            sort,
        },
        data: () => ({
            studio: {
                name: '',
                fans: 0,
                views: 0,
                digest: '',
                thumb: '',
            },
        }),
        computed: {
            id() {
                return +this.$route.params.id || 0;
            },
        },
        beforeMount() {
            this.api.get(`studios/${this.id}`).then(e => this.studio = e, this.err);
        }
    }
</script>

<style scoped>
    @import '../../../static/css/dancer/detail.css';
    @import '../../../static/css/home/video-list.css';
</style>


// WEBPACK FOOTER //
// src/components/studio/Detail.vue